import { render, staticRenderFns } from "./champ_textarea.vue?vue&type=template&id=3dfbc0b8"
import script from "./champ_textarea.js?vue&type=script&lang=js&external"
export * from "./champ_textarea.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports